import React, { Suspense, type FunctionComponent } from "react";
import {
  type IPost,
  PostStatus,
} from "../../../../types/models/post.models.types";
import Spinner from "../../../../components/spinner.components";
import type { ICampaign } from "../../../../types/models/campaign.models.types";
import { SocialPlatforms } from "../../../../types/models/social.models.types";
import { YouTubeEmbed } from "react-social-media-embed";
import { pauseOtherVideos } from "../../../../utils/utils";

const InstagramEmbed = React.lazy(() =>
  import("react-social-media-embed").then((module) => ({
    default: module.InstagramEmbed,
  })),
);

interface IProps {
  post: IPost;
  campaign: ICampaign;
}

export const CampaignPostMediaAdminPartial: FunctionComponent<IProps> = ({
  post,
  campaign,
}) => {
  switch (post.postStatus.status) {
    case PostStatus.draft:
    case PostStatus.draftApproved:
    case PostStatus.draftRejected:
      return (
        <>
          <div className="relative flex justify-center items-center w-full aspect-[9/16]">
            {/* biome-ignore lint/a11y/useMediaCaption: <explanation> */}
            <video
              controls={true}
              src={post.draftAsset?.url}
              className="w-full cursor-pointer object-cover"
              onPlay={(e) => pauseOtherVideos(e.currentTarget)}
            />
          </div>

          <div className="flex flex-col px-6 pt-5 pb-8 w-full font-semibold text-base">
            <p>{post.draftDescription}</p>
          </div>
        </>
      );
    case PostStatus.post:
    case PostStatus.postApproved:
    case PostStatus.postRejected:
    case PostStatus.disqualify:
    case PostStatus.flagged:
    case PostStatus.flaggedReview:
      if (!post.liveUrl) {
        throw new Error("live url not found");
      }
      if (campaign.socialPlatform === SocialPlatforms.instagram) {
        return (
          <>
            <div className="overflow-hidden">
              <Suspense fallback={<Spinner width={20} />}>
                <InstagramEmbed
                  className="w-full"
                  url={post.liveUrl}
                  height={645}
                  width={390}
                  captioned={true}
                />
              </Suspense>
            </div>
          </>
        );
      }
      if (campaign.socialPlatform === SocialPlatforms.youtube) {
        return (
          <>
            <div className="overflow-hidden">
              <Suspense fallback={<Spinner width={20} />}>
                <YouTubeEmbed
                  className="w-full"
                  url={post.liveUrl}
                  height={645}
                  width={380}
                />
              </Suspense>
            </div>
          </>
        );
      }
  }
};
